// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Color } from '../../../Graphics';
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { InputParameterInteger } from '../InputParamaterClasses/InputParameterInteger';
export class StopATR extends IndicatorScriptBase {
    constructor() {
        super();
        // #region Initialization
        this.DateOfCreation = '02.05.2020';
        this.ExpirationDate = 0;
        this.Version = '';
        this.Password = '66b4a6416f59370e942d353f08a9ae36';
        this.ProjectName = 'StopATR';
        // #endregion
        this.SetIndicatorLine('Neutral Line', Color.LightGray, 2, LineStyle.SimpleChart);
        this.SeparateWindow = false;
        this.hi = [];
        this.stop = [];
        this.Period = 20;
        super.InputParameter(new InputParameterInteger('Period', 'Period', 0, 1, 99999));
        this.Multiplier = 2;
        super.InputParameter(new InputParameterInteger('Multiplier', 'Multiplier', 1, 1, 99999));
    }
    Init() {
        this.IndicatorShortName(this.GetIndicatorShortName());
    }
    GetIndicatorShortName() {
        return 'StopATR(' + this.Period + ', ' + this.Multiplier + ')';
    }
    getCustomName() {
        return 'StopATR (' + this.ProjectName + ')';
    }
    createInternalIndicators() {
        this.atr = this.Indicators.iATR(this.CurrentData, this.Period);
        return [this.atr];
    }
    OnQuote() {
        super.OnQuote();
        if (this.CurrentData.Count <= this.Period) {
            return;
        }
        const max = this.CurrentData.getPriceByType(PriceType.Close, 1) + this.atr.GetValue(0, 1) * this.Multiplier;
        const min = this.CurrentData.getPriceByType(PriceType.Close, 1) - this.atr.GetValue(0, 1) * this.Multiplier;
        const prevHi = this.hi[this.hi.length - 1 - 1];
        const prevHigh = this.CurrentData.getPriceByType(PriceType.High, 1);
        const prevStop = this.stop[this.stop.length - 1 - 1];
        const prevLow = this.CurrentData.getPriceByType(PriceType.Low, 1);
        this.hi[this.hi.length - 1] = prevHi ? !(prevHigh >= prevStop) : prevLow <= prevStop;
        const hi = this.hi[this.hi.length - 1];
        this.stop[this.stop.length - 1] = hi ? max : min;
        const stop = this.stop[this.stop.length - 1];
        this.stop[this.stop.length - 1] = hi
            ? prevHi === false
                ? stop
                : stop > prevStop
                    ? prevStop
                    : stop
            : prevHi
                ? stop
                : stop < prevStop
                    ? prevStop
                    : stop;
        this.SetValue(0, this.stop[this.stop.length - 1]);
        hi ? this.SetMarker(0, Color.Lime) : this.SetMarker(0, Color.Red);
    }
    NextBar() {
        super.NextBar();
        this.hi.push(true);
        this.stop.push(0);
    }
}
